<template>
  <div class="introduce">
    <div class="top">
      <span>树莓智慧校园平台</span>
      <span>提升学校的安全防范能力，创造高效便捷的智能化校园管理体验</span>
    </div>
    <h3>未来校园版本图</h3>
    <div class="short_stub">
      <div></div>
      <div></div>
    </div>
    <span
      class="jieshao"
    >未来校园整体解决方案是面向学校泛园区场景，采用前端智能化人脸终端和云端集中管理平台架构，实现校园防疫测温、人员管理、访客管理、考勤管理、通行管理、校园电话和远程查寝等应用，并结合微信和钉钉平台，实现校方和家长的互动、考勤推送、成绩查询等多方位可视化数据应用整体解决方案。</span>
    <div class="content_gn">
		<img src="../assets/ztjjfa.jpg" />
      <!-- <div class="item_gn">
        <img src="//static.h5.ylmob.com/website/img/guanli.png" />
        <span>通行管理</span>
      </div>
      <div class="item_gn">
        <img src="//static.h5.ylmob.com/website/img/kaoqing.png" />
        <span>学生考勤</span>
      </div>
      <div class="item_gn">
        <img src="//static.h5.ylmob.com/website/img/qingjia.png" />
        <span>学生请假</span>
      </div>
      <div class="item_gn">
        <img src="//static.h5.ylmob.com/website/img/fangke.png" />
        <span>访客管理</span>
      </div>
      <div class="item_gn">
        <img src="//static.h5.ylmob.com/website/img/dainhua.png" />
        <span>校园电话</span>
      </div>
    </div>
    <div class="content_gn">
      <div class="item_gn">
        <img src="//static.h5.ylmob.com/website/img/daping.png" />
        <span>防疫大屏</span>
      </div>
      <div class="item_gn">
        <img src="//static.h5.ylmob.com/website/img/ceweng.png" />
        <span>人脸测温</span>
      </div>
      <div class="item_gn">
        <img src="//static.h5.ylmob.com/website/img/hudong.png" />
        <span>家校互动</span>
      </div>
      <div class="item_gn">
        <img src="//static.h5.ylmob.com/website/img/chengji.png" />
        <span>成绩管理</span>
      </div>
      <div class="item_gn">
        <img src="//static.h5.ylmob.com/website/img/tongzhi.png" />
        <span>通知管理</span>
      </div> -->
    </div>
    <h3>产品解决方案</h3>
    <div class="short_stub">
      <div></div>
      <div></div>
    </div>
    <div class="fa_name">
      <div class="fa_name_i">
        <span :style="{color:faIndex==0?'rgba(47,110,240,1)':''}">人脸识别通道系统</span>
        <div v-if="faIndex==0" class="fa_name_i_line"></div>
      </div>
      <div class="fa_name_i">
        <span :style="{color:faIndex==1?'rgba(47,110,240,1)':''}">寝室就寝管理</span>
         <div v-if="faIndex==1" class="fa_name_i_line"></div>
      </div>
      <div class="fa_name_i">
        <span :style="{color:faIndex==2?'rgba(47,110,240,1)':''}">校园电话系统</span>
         <div v-if="faIndex==2" class="fa_name_i_line"></div>
      </div>
      <div class="fa_name_i">
        <span :style="{color:faIndex==3?'rgba(47,110,240,1)':''}">红外测温系统</span>
         <div v-if="faIndex==3" class="fa_name_i_line"></div>
      </div>
      <div class="fa_name_i">
        <span :style="{color:faIndex==4?'rgba(47,110,240,1)':''}">校园健康监控中台</span>
         <div v-if="faIndex==4" class="fa_name_i_line"></div>
      </div>
    </div>
    <swiper class="swiper" :options="swiperOption">
      <swiper-slide>
        <div class="fa_item">
          <div class="fa_item_l">
            <img src="//static.h5.ylmob.com/website/img/shibie.png" />
          </div>
          <div class="fa_item_r">
            <div class="fa_item_r_i">
              <img src="//static.h5.ylmob.com/website/img/tongxing.png" />
              <div class="fa_item_r_i_d">
                <span>通行管理</span>
                <span>学生、教师进出人脸识别通道，系统自动抓拍人脸进行对比识别，根据识别人员权限给予开闸操作</span>
              </div>
            </div>
            <div class="fa_item_r_i">
              <img src="//static.h5.ylmob.com/website/img/jilu.png" />
              <div class="fa_item_r_i_d">
                <span>通行记录</span>
                <span>自动记录每一个通行人员的身份信息和时间，学生到/离校记录推送至家长微信账号</span>
              </div>
            </div>
            <div class="fa_item_r_i">
              <img src="//static.h5.ylmob.com/website/img/tongji.png" />
              <div class="fa_item_r_i_d">
                <span>数据统计</span>
                <span>识别数据实时在看板主机屏幕上显示，包括人员姓名、班级、类型以及外出事由等</span>
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="fa_item">
          <div class="fa_item_l">
            <img src="//static.h5.ylmob.com/website/img/img_qingshi.png" />
          </div>
          <div class="fa_item_r">
            <div class="fa_item_r_i">
              <img src="//static.h5.ylmob.com/website/img/icon_qs_guanli.png" />
              <div class="fa_item_r_i_d">
                <span>寝室管理</span>
                <span>管理分配学生住宿信息，跟踪住校学生的就寝情况</span>
              </div>
            </div>
            <div class="fa_item_r_i">
              <img src="//static.h5.ylmob.com/website/img/icon_qs_tixing.png" />
              <div class="fa_item_r_i_d">
                <span>就寝提醒</span>
                <span>自动记录各寝室人员就寝信息，对未归就寝人员作标注提醒</span>
              </div>
            </div>
            <div class="fa_item_r_i">
              <img src="//static.h5.ylmob.com/website/img/icon_qs_tongji.png" />
              <div class="fa_item_r_i_d">
                <span>数据统计</span>
                <span>即时显示宿舍出入口人员信息，包括人员姓名、班级、寝室号等，自动统计人员就寝数据</span>
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="fa_item">
          <div class="fa_item_l">
            <img src="//static.h5.ylmob.com/website/img/img_dianhua.png" />
          </div>
          <div class="fa_item_r">
            <div class="fa_item_r_i">
              <img src="//static.h5.ylmob.com/website/img/icon_dh_yuyin.png" />
              <div class="fa_item_r_i_d">
                <span>语音通话</span>
                <span>人脸验证后语音电话呼叫家长学生手机，方便学生和家长即时沟通</span>
              </div>
            </div>
            <div class="fa_item_r_i">
              <img src="//static.h5.ylmob.com/website/img/icon_dh_guanli.png" />
              <div class="fa_item_r_i_d">
                <span>通话管理</span>
                <span>管理学生家长通讯录，自动记录通话记录和扣费记录</span>
              </div>
            </div>
            <div class="fa_item_r_i">
              <img src="//static.h5.ylmob.com/website/img/icon_dh_chongzhi.png" />
              <div class="fa_item_r_i_d">
                <span>充值缴费</span>
                <span>在线充值电话账号余额，查询充值记录，账号余额等</span>
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="fa_item">
          <div class="fa_item_l">
            <img src="//static.h5.ylmob.com/website/img/img_hongwai.png" />
          </div>
          <div class="fa_item_r">
            <div class="fa_item_r_i">
              <img src="//static.h5.ylmob.com/website/img/icon_hw_shibie.png" />
              <div class="fa_item_r_i_d">
                <span>人脸识别</span>
                <span>通过人脸识别快速确实当前人员信息，支持离线工作</span>
              </div>
            </div>
            <div class="fa_item_r_i">
              <img src="//static.h5.ylmob.com/website/img/icon_hw_cewen.png" />
              <div class="fa_item_r_i_d">
                <span>红外测温</span>
                <span>配备高精度热成像传感器，快速捕捉当前人脸体温数据并上传</span>
              </div>
            </div>
            <div class="fa_item_r_i">
              <img src="//static.h5.ylmob.com/website/img/icon_hw_warn.png" />
              <div class="fa_item_r_i_d">
                <span>异常告警</span>
                <span>异常温度触发声光告警，有效提醒监管人员及时介入</span>
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="fa_item">
          <div class="fa_item_l">
            <img src="//static.h5.ylmob.com/website/img/img_zhongtai.png" />
          </div>
          <div class="fa_item_r">
            <div class="fa_item_r_i">
              <img src="//static.h5.ylmob.com/website/img/icon_hw_cewen.png" />
              <div class="fa_item_r_i_d">
                <span>人脸测温</span>
                <span>前端设备实时上报最新人脸测温数据至云端，后台自动进行数据统计与可视化展现</span>
              </div>
            </div>
            <div class="fa_item_r_i">
              <img src="//static.h5.ylmob.com/website/img/icon_zt_gaikuang.png" />
              <div class="fa_item_r_i_d">
                <span>学校概况</span>
                <span>概况性说明当前学校总人数、请假人数、已测温人数和异常人数，展示当前健康状态</span>
              </div>
            </div>
            <div class="fa_item_r_i">
              <img src="//static.h5.ylmob.com/website/img/icon_zt_banji.png" />
              <div class="fa_item_r_i_d">
                <span>班级体温监测</span>
                <span>以班级和教职工分组展现，实时滚动当前未排查人员和异常人员测温情况</span>
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
    <div class="dingwei">
      <h3 style="color:rgba(255,255,255,1);">微信&钉钉</h3>
      <div class="short_stub">
        <div style="background:rgba(255,255,255,1);"></div>
        <div style="background:rgba(255,255,255,1);"></div>
      </div>
      <span
        class="dingwei_d"
      >根据校园实际应用需求，自主选择微信或钉钉作为移动端，为教师和家长提供智能化校园应用，随时随地掌握在校学生最新生活和学习情况。同时通过钉钉对接，实现组织机构和家校通讯录自动同步，减轻校务数据运维工作。</span>
      <div class="dingwei_c">
        <img src="//static.h5.ylmob.com/website/img/dingding.png" />
        <div class="dingwei_c_c">
          <div class="dingwei_c_s"></div>
<!--          <img src="//static.h5.ylmob.com/website/img/img_phone.png" />-->
          <img src="@/assets/phone.png" />
        </div>
        <img src="//static.h5.ylmob.com/website/img/weixin.png" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    const that = this;
    return {
      faIndex: 0,
      swiperOption: {
        prevButton: '.swiper-button-prev',
        nextButton: '.swiper-button-next',
        onTransitionStart (swiper) {
            console.log("swiper:  " + swiper.realIndex)
            that.faIndex = swiper.realIndex;
          }
        // on: {
        //   slideChangeTransitionStart: function() {
        //     that.faIndex = this.realIndex;
        //     console.log("获取下标：  " + this.realIndex);
        //   }
        // }
      }
    };
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {}
};
</script>
<style scoped>
.introduce {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.top {
  width: 100%;
  height: 2.604167rem;
  background: url("//static.h5.ylmob.com/website/img/img_top.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.top span:nth-child(1) {
  font-size: .3125rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: .3125rem;
}
.top span:nth-child(2) {
  font-size: .15625rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.75);
  line-height: .15625rem;
  margin-top: 0.15625rem;
}
.jieshao {
  width: 5.208333rem;
  font-size: .083333rem;
  font-weight: 400;
  color: rgba(9, 22, 48, 1);
  line-height: .125rem;
  text-align: left;
  margin-bottom: 0.416667rem;
}
.content_gn {
  width: 5.208333rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.260417rem;
}
.content_gn img{
	width: 5.208333rem;
}
.item_gn {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.item_gn img {
  width: 0.46875rem;
  height: 0.46875rem;
  margin-bottom: 0.088542rem;
}
.item_gn span {
  font-size: .072917rem;
  font-weight: 400;
  color: rgba(9, 22, 48, 1);
  line-height: .072917rem;
}
.swiper {
  width: 6.25rem;
}
.fa_item {
  width: 6.25rem;
  display: flex;
  align-items: center;
}
.fa_item_l {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.fa_item_l img {
  width: 2.291667rem;
  height: 2.291667rem;
}
.fa_item_r {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.fa_item_r_i {
  display: flex;
  /* align-items: center; */
  margin-bottom: 0.3125rem;
}
.fa_item_r_i img {
  width: 0.3125rem;
  height: 0.3125rem;
  margin-right: 0.15625rem;
  flex-shrink: 0;
}
.fa_item_r_i_d {
  width: 1.5625rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.fa_item_r_i_d span:nth-child(1) {
  font-size: .104167rem;
  font-weight: 500;
  color: rgba(9, 22, 48, 1);
  line-height: .104167rem;
  text-align: left;
}
.fa_item_r_i_d span:nth-child(2) {
  font-size: .072917rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(9, 22, 48, 0.65);
  line-height: .104167rem;
  margin-top: 0.052083rem;
  text-align: left;
}
.dingwei {
  width: 100%;
  height: 5.505208rem;
  background: rgba(47, 110, 240, 1);
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 0.208333rem;
}
.dingwei_d {
  width: 3.125rem;
  font-size: .083333rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: .125rem;
  text-align: left;
}
.dingwei_c {
  display: flex;
  align-items: center;
  margin-top: 0.260417rem;
}
.dingwei_c img {
  width: 0.520833rem;
  height: 0.520833rem;
}
.dingwei_c_c {
  position: relative;
  width: 3.385417rem;
  height: 3.385417rem;
  /* background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.05) 0%,
    rgba(255, 255, 255, 0.54) 100%
  ); */
  background:rgba(255, 255, 255, 0.05);
  /* opacity: 0.05; */
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 0.911458rem;
}
.dingwei_c_s {
  width: 2.5rem;
  height: 2.5rem;
  /* background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.1) 0%,
    rgba(255, 255, 255, 0.54) 100%
  ); */
  background:rgba(255, 255, 255, 0.1);
  /* opacity: 0.1; */
  border-radius: 50%;
}
.dingwei_c_c img {
  position: absolute;
  width: 2.940625rem;
  height: 2.953125rem;
}
.fa_name {
  width: 6.25rem;
  display: flex;
  justify-content: center;
  margin-bottom: .416667rem;
  border-bottom: .010417rem solid rgba(242,242,242,1);
}
.fa_name_i {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 0.260417rem;
}
.fa_name_i span {
  font-size: 0.09375rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(9, 22, 48, 1);
  line-height: 0.09375rem;
}
.fa_name_i_line {
  width: .3125rem;
  height: .010417rem;
  background: rgba(47, 110, 240, 1);
  border-radius: 1px;
  margin-top: .104167rem;
}
</style>
